import * as DashboardActions from './dashboard.actions';

export { DashboardActions };
